<script lang="ts">
	import Input from '$lib/components/Global/Fields/Input.svelte';
	import { onMount, type ComponentProps } from 'svelte';
	import FieldWrapper from './FieldWrapper.svelte';
	import countries, { type Country } from '../../Survey/fields/PhoneInput/countries';
	import ChevronRight from '$lib/assets/images/icons/chevron-right.svg?component';

	export let name: string;
	export let dialCodeName: string = 'prefix';

	interface $$Props extends ComponentProps<Input> {
		name: string;
		defaultCode?: string;
	}

	let value: string = '';

	export let defaultCode: string = 'PT';
	let selectedCode: string = defaultCode;
	selectedCode = defaultCode;
	let selectedCountry: Country | undefined;
	$: selectedCountry = countries.find((country) => country.code === selectedCode);

	let input: HTMLInputElement;
	onMount(() => {
		input = document.querySelector(`input[name="${name}"]`) as HTMLInputElement;
	});

	function strToNumbers(value: string) {
		return value.replace(/\D/g, '');
	}
</script>

<FieldWrapper
	{name}
	onUpdate={(value) => ({
		[dialCodeName]: selectedCountry?.dial_code || '',
		[name]: strToNumbers(value)
	})}
	let:handleUpdate
	let:error
	on:value={(e) => {
		value = e.detail || '';
	}}
>
	<Input type="tel" {name} {value} {error} {...$$restProps} on:input={handleUpdate} inputmode="tel">
		<div slot="left" class="relative">
			<input type="hidden" name="prefix" value={selectedCountry?.dial_code || ''} />
			<select
				bind:value={selectedCode}
				on:change={() => input.dispatchEvent(new Event('input'))}
				class="flex w-[85px] appearance-none items-center rounded-sm bg-secondary pl-1 text-white outline-none"
			>
				{#each countries as country}
					<option selected={country.code === selectedCountry?.code} value={country.code}
						>{country.emoji} {country.dial_code}</option
					>
				{/each}
			</select>
			<span class="pointer-events-none absolute right-0 top-0 flex h-full w-3 items-center">
				<ChevronRight class="h-2 rotate-90 stroke-white stroke-[10px]" />
			</span>
		</div>
	</Input>
</FieldWrapper>
